import { renderRoutes } from 'react-router-config'
import React, { useEffect, useMemo } from 'react'
import { FacebookProvider } from 'react-facebook'
import { authToken } from '@/utils/helper'
import { useQuery } from 'react-query'
import { get } from '@/pages/lna/utils/fetch'
import useTA from '@/pages/lna/hooks/useTA'
import { isPC } from '@/utils'
import {
  useStoreReducer,
  StoreContext,
  storeActionType,
} from '@/pages/sea/context'

import {
  useStoreReducer as useLnaStoreReducer,
  StoreContext as LnaStoreContext,
  storeActionType as LnaStoreActionType,
} from '@/pages/lna/context'
import { TOKEN_KEY } from '@/utils/cookie'

/**
 * BaseLayout
 */
const BaseLayout = (props: React.PropsWithChildren<any>) => {
  const { route, children } = props
  const [store, dispatch] = useStoreReducer()

  const [storeLna, dispatchLna] = useLnaStoreReducer()
  const { initTa } = useTA()

  useEffect(() => {
    initTa?.()
  }, [initTa])

  const storeCtxValue = useMemo(() => ({ store, dispatch }), [dispatch, store])

  const storeLnaCtxValue = useMemo(
    () => ({ store: storeLna, dispatch: dispatchLna }),
    [dispatchLna, storeLna]
  )

  useEffect(() => {
    const { pathname, search } = window.location
    //  处理预注册页面路径
    if (pathname?.includes('reserve')) return
    const path = pathname.slice(1).split('/') || []
    if (isPC()) {
      if (path[0] === 'm') {
        window.location.replace(`/${path.slice(1).join('/')}${search}`)
      }
    } else if (path[0] !== 'm') {
      window.location.replace(`/m${pathname}${search}`)
    }
  }, [])

  useQuery<unknown, ReturnData | Error, ReturnData>(
    '/api/reservation/download',
    async () => get('/api/reservation/download'),
    {
      refetchOnWindowFocus: false,
      retry: false,
      onSuccess: (res) => {
        dispatchLna({
          type: LnaStoreActionType.UPDATE_DOWNLOAD_INFO,
          data: res?.data,
        })
      },
    }
  )

  useEffect(() => {
    if (authToken()) {
      dispatch({
        type: storeActionType.LOGIN_STATUS,
        data: true,
      })
      dispatch({
        type: storeActionType.USER_INFO,
        data: JSON.parse(localStorage.getItem(TOKEN_KEY) || '{}')?.account_info,
      })
    }
  }, [dispatch])

  const lang = localStorage.getItem('i18nextLng') || 'en'
  return (
    <div className="layout-container">
      <FacebookProvider appId="820791479705055" language={lang}>
        <LnaStoreContext.Provider value={storeLnaCtxValue}>
          <StoreContext.Provider value={storeCtxValue}>
            {renderRoutes(route.routes)}
            {children}
          </StoreContext.Provider>
        </LnaStoreContext.Provider>
      </FacebookProvider>
    </div>
  )
}

export default React.memo(BaseLayout)
